const config = {
  appSettings: {
    tus: true,
    tusd: true, // nodejs server or GO tusd server
    chunkSize: 10 * 1024 * 1024,
    parallelUploads: 5,
    endpoint: 'https://www.lifeapp.com/tusd/'
  },
  maxFileSize: 5 * 1024 * 1024 * 1024,
  maxFileCount: 10,
  features: {
    // ask the user to enable chat notifications after login (was hard-disabled in code)
    chatNotificationPrompt: false
  },

  site_name: 'MedChat',
  env: process.env.NODE_ENV,
  api_local: parseInt(process.env.API_LOCAL) || 0,
  editTreatmentsTime: 1000 * 60 * 60 * 72, // 72 hours
  removeAnalysesTime: 1000 * 60 * 60, // 72 hours
  refundTime: 1000 * 60 * 60 * 24 * 30, // 30 days
  content: {
    limit: 50
  },
  // httpApi: ['https://api1.foxmed.net:4443'],
  httpApi: [''],
  // tus: [location.protocol + '//' + location.host],
  tus: [''],
  redirectUri: 'https://www.lifeapp.com',
  websocket: {
    url: 'wss://www.lifeapp.com:8081/sockjs',
    api: '',
    pingInterval: 50 * 1000,
    maxPingInterval: 2 * 60 * 1000,
    maxWaitingForcePing: 5 * 1000
  },
  imageServer: '//img.foxmed.net',
  cdnImageServer: '//cdn.lifeapp.com/storage',
  thumb: 'http://static.contentvoo.com/media/thumb_no_man.png',
  sessionPrefix: 'medchat_',
  progress: {
    enable: '0',
    interval: 150,
    min: 2,
    max: 6
  },
  map: {
    geocode_url: 'https://geocode.search.hereapi.com/v1/geocode',
    base_url: 'https://image.maps.hereapi.com/mia/v3/base/mc/',
    api_id: 'pTYlZUHo5cAwoNRNQKQJ',
    api_key: 'p4p8_Mx8FfE6s7qk3Kj3sHREz3LiMDr5_AQw9Rmkni8'
  },
  googleMaps: {
    apiKey: 'AIzaSyDLQwWHVqmx1ATohazt05qB_lZhlTHOtJg'
  },
  googleAuth: {
    client_id: '140629974592-u8du9k7ac3klht6d34b2b57dt22hq916.apps.googleusercontent.com',
    response_type: 'code',
    scope: 'openid email profile',
    access_type: 'offline',
    redirect_uri: 'https://lifeapp.com/oauth',
    prompt: 'select_account'
  },
  stripe: {
    publishableKey:
      'pk_test_51Pew2dGDeqTi0NXti1THrgaWBNGBKJIAVhiTCCv5Eha27L65ssziPOX7acXh4nSFkXQXYiloJ2Vkrzbvm9y1DLCz00aqTm1IGW'
  },
  logger: {
    api: true,
    events: true,
    model: true,
    component: true,
    debug: true,
    warn: true,
    state: false,
    websocket: true
  }
};

export default config;
